export const prntOptList = [
  { label: 'Both', value: 'B' },
  { label: 'Detail', value: 'D' },
  { label: 'Summary', value: 'S' }
]

export const driList = [
  { label: 'Both', value: 'B' },
  { label: 'Direct', value: 'D' },
  { label: 'RI', value: 'R' }
]
